/*global tracking, FakeCation*/
(function (FC) {
  "use strict";

  FC.utils.registerFilter('grayscale', function (imgData, cb) {
    var gsData = tracking.Image.grayscale(imgData.data, imgData.width, imgData.height, true);

    cb(new window.ImageData(gsData, imgData.width, imgData.height));
  });
}(FakeCation));
